import React from 'react';
interface Particle {
  left: string;
  top: string;
  size: number;
  duration: number;
  delay: number;
}
const PARTICLES: Particle[] = [{
  left: '6%',
  top: '22%',
  size: 6,
  duration: 15,
  delay: 0
}, {
  left: '18%',
  top: '68%',
  size: 4,
  duration: 19,
  delay: 1.5
}, {
  left: '31%',
  top: '12%',
  size: 5,
  duration: 17,
  delay: 3
}, {
  left: '44%',
  top: '82%',
  size: 3,
  duration: 21,
  delay: 0.8
}, {
  left: '58%',
  top: '30%',
  size: 6,
  duration: 16,
  delay: 2.4
}, {
  left: '71%',
  top: '74%',
  size: 4,
  duration: 20,
  delay: 4
}, {
  left: '84%',
  top: '18%',
  size: 5,
  duration: 18,
  delay: 1.1
}, {
  left: '93%',
  top: '58%',
  size: 3,
  duration: 22,
  delay: 3.6
}];
export function Particles() {
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-104" data-mp="1mihpenj7mi5i">
      {PARTICLES.map((p, i) => <span key={i} className="particle" style={{
      left: p.left,
      top: p.top,
      width: `${p.size}px`,
      height: `${p.size}px`,
      animationDuration: `${p.duration}s`,
      animationDelay: `${p.delay}s`
    }} data-id="element-105" data-mp="2f0wsjwn881oj" data-mpi={i} />)}
    </div>;
}